import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, timer } from 'rxjs';
import { filter, scan, takeUntil, tap } from 'rxjs/operators';

import { RemoteDiagnosticsStore } from '@store';

@Component({
  selector: 'app-diagnostics-connection-force-disconnect',
  templateUrl: './diagnostics-connection-force-disconnect.component.html',
  styleUrls: ['./diagnostics-connection-force-disconnect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticsConnectionForceDisconnectComponent implements OnInit, OnDestroy {
  constructor(
    public remoteDiagnosticsStore: RemoteDiagnosticsStore,
    private dialogRef: MatDialogRef<DiagnosticsConnectionForceDisconnectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { gatewaySerial: string },
    private cdr: ChangeDetectorRef
  ) {}

  private readonly counterStepInterval = 1000; // in milliseconds
  private readonly counterStartValue = 9;

  public disconnectCounter: number;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    timer(0, this.counterStepInterval)
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        scan((accumulator) => --accumulator, this.counterStartValue),
        tap((valueCounter) => {
          this.disconnectCounter = valueCounter;
          this.cdr.detectChanges();
        }),
        filter((value) => value === 0),
        tap(() => {
          this.remoteDiagnosticsStore.triggerDisconnectSequence(this.data.gatewaySerial);
          this.dialogRef.close();
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  extendSession(): void {
    this.remoteDiagnosticsStore.lastUserActivityTimestampReset(this.data.gatewaySerial);
    this.dialogRef.close();
  }
}
